import type { DeepMaybeRef } from "@vueuse/core";
import type { ScenarioCalculations } from "../calculationTypes";
import type { DestructuredScenario } from "@/composables/useDestructureScenario";
import { ref } from "vue";

export const createScenarioCalcInputs = (
  destructuredScenario: DeepMaybeRef<DestructuredScenario>,
  overrides?: Partial<ScenarioCalculations>
) => {
  // // Extract upholeStack parameter, defaulting to true (upper stack)
  // // Type assertion for type-safe access
  // const upholeStack =
  //   (extraParameters as { upholeStack?: boolean } | undefined)?.upholeStack !==
  //   false;
  // const stack: Stack = upholeStack ? "upper" : "lower";
  const {
    scenario,
    equipment,
    wellProperties,
    parameters,
    correlations,
    pumps,
    seals,
    intakes,
    housings,
    cables,
    deviationSurvey,
    yToolBypassTubings,
    yToolEquipmentTubings
  } = destructuredScenario;
  // // Store original unfiltered equipment for offset calculation
  // // This allows us to access upper stack y-tool bypass tubing when calculating lower stack
  // // Use toValue to unwrap the ref if needed
  // const originalEquipment = computed(() => toValue(equipment));

  // // Apply filtering based on stack (upper or lower)
  // // For upper stack, no filtering needed - use data as-is
  // // For lower stack, filter equipment, parameters, and wellProperties
  // const filteredEquipment = computed(() =>
  //   createFilteredEquipmentObject(toValue(equipment), stack)
  // );
  // const filteredParameters = computed(() =>
  //   createStackAwareParameters(toValue(parameters), stack)
  // );
  // const filteredWellProperties = computed(() =>
  //   createStackAwareWellProperties(toValue(wellProperties), stack)
  // );

  // // Filter equipment maps based on stack
  // const filteredPumps = computed(() => {
  //   if (upholeStack) {
  //     return toValue(pumps);
  //   }
  //   const originalEquip = originalEquipment.value;
  //   const lowerPumpsOrder =
  //     (originalEquip?.lower_pumps_order as string[] | undefined) || [];
  //   return filterEquipmentMapByOrder(toValue(pumps), lowerPumpsOrder);
  // });

  // const filteredIntakes = computed(() => {
  //   if (upholeStack) {
  //     return toValue(intakes);
  //   }
  //   const originalEquip = originalEquipment.value;
  //   const lowerIntakesOrder =
  //     (originalEquip?.lower_intakes_order as string[] | undefined) || [];
  //   return filterEquipmentMapByOrder(toValue(intakes), lowerIntakesOrder);
  // });

  // const filteredSeals = computed(() => {
  //   if (upholeStack) {
  //     return toValue(seals);
  //   }
  //   const originalEquip = originalEquipment.value;
  //   const lowerSealsOrder =
  //     (originalEquip?.lower_seals_order as string[] | undefined) || [];
  //   return filterEquipmentMapByOrder(toValue(seals), lowerSealsOrder);
  // });

  // const filteredCables = computed(() => {
  //   if (upholeStack) {
  //     return toValue(cables);
  //   }
  //   const originalEquip = originalEquipment.value;
  //   const lowerCablesOrder =
  //     (originalEquip?.lower_cables_order as string[] | undefined) || [];
  //   return filterEquipmentMapByOrder(toValue(cables), lowerCablesOrder);
  // });

  // // Filter housings: only include housings from filtered pumps
  // const filteredHousings = computed(
  //   (): Record<string, XrefHousings[number]> => {
  //     if (upholeStack) {
  //       return toValue(housings);
  //     }
  //     const originalEquip = originalEquipment.value;
  //     const lowerPumpsOrder =
  //       (originalEquip?.lower_pumps_order as string[] | undefined) || [];
  //     const pumpsMap = filteredPumps.value;
  //     const housingsMap = toValue(housings);

  //     return filterHousingsByPumpOrder(lowerPumpsOrder, pumpsMap, housingsMap);
  //   }
  // );

  // // Create refs from filtered data
  // const _scenario = ref(scenario);
  // const _equipment = ref(filteredEquipment);
  // const _wellProperties = ref(filteredWellProperties);
  // const _parameters = ref(filteredParameters);
  // const _correlations = ref(correlations);
  // const _pumps = ref(filteredPumps);
  // const _seals = ref(filteredSeals);
  // const _intakes = ref(filteredIntakes);
  // const _housings = ref(filteredHousings);
  // const _cables = ref(filteredCables);
  // const _deviationSurvey = ref(deviationSurvey);

  const _scenario = ref(scenario);
  const _equipment = ref(equipment);
  const _wellProperties = ref(wellProperties);
  const _parameters = ref(parameters);
  const _correlations = ref(correlations);
  const _pumps = ref(pumps);
  const _seals = ref(seals);
  const _intakes = ref(intakes);
  const _housings = ref(housings);
  const _cables = ref(cables);
  const _yToolBypassTubings = ref(yToolBypassTubings);
  const _yToolEquipmentTubings = ref(yToolEquipmentTubings);
  const _deviationSurvey = ref(deviationSurvey);

  return {
    destructuredScenario,
    overrides,
    scenario,
    equipment,
    wellProperties,
    parameters,
    correlations,
    pumps,
    seals,
    intakes,
    housings,
    cables,
    deviationSurvey,
    yToolBypassTubings,
    yToolEquipmentTubings,
    _scenario,
    _equipment,
    _wellProperties,
    _parameters,
    _correlations,
    _pumps,
    _seals,
    _intakes,
    _housings,
    _cables,
    _yToolBypassTubings,
    _yToolEquipmentTubings,
    _deviationSurvey
  };
};

export type ScenarioCalcInputs = ReturnType<typeof createScenarioCalcInputs>;
